/**
 * Resolves a "show" flag from the legacy customize model: if an explicit
 * toggle is provided use it, otherwise infer visibility from whether a
 * value is present. Used by the customize→design converter.
 */
export function showOrInfer(
  explicitToggle: boolean | null | undefined,
  value: unknown
): boolean {
  return explicitToggle != null ? Boolean(explicitToggle) : Boolean(value)
}
